import React from 'react'

const Header = () => {
  return (
    <div className='mx-auto max-w-sm flex flex-col content-center font-bold text-4xl pb-8'>Deep Skin</div>
  )
}

export default Header